"use strict";

module.exports = function isTwelveHourTime(groups) {
  return (/[a-z]/i.test(groups[groups.length - 1])
  );
};